var _rect, _circle, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 60",
    role: "img",
    "aria-label": "SMART on FHIR",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 238,
    height: 58,
    rx: 10,
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 30,
    r: 12,
    fill: "#f59f19"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30 L25 35 L32 25",
    stroke: "#ffffff",
    strokeWidth: 2.6,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 38,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 700,
    fill: "#3a2716",
    letterSpacing: 0.5
  }, "SMART on FHIR")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmart);
export default __webpack_public_path__ + "static/media/smart.b2bd98d44f7530d86e2cc7188beaf2d0.svg";
export { ForwardRef as ReactComponent };